import { LearningPathColors } from '~/dashboard/types/dashboard.types'

export enum TopicId {
  ALGEBRA = 'algebra',
  FUNCTIONS = 'functions',
  GEOMETRY = 'geometry',
  NUMBERS = 'numbers-and-quantities',
  PROOFS = 'proofs',
  STATISTICS = 'statistics-and-probability',
}

export function getPathGradientColors(topicId: TopicId): LearningPathColors {
  switch (topicId) {
    case TopicId.ALGEBRA:
      return {
        start: '#467BFF',
        stop: '#6994FF',
        faded: '#93C5FF',
        colorMatrix: '0 0 0 0 0.223529 0 0 0 0 0.396078 0 0 0 0 0.827451 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.394027 0 0 0 0 0.592601 0 0 0 0 0.890462 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }

    case TopicId.FUNCTIONS:
      return {
        start: '#FF5630',
        stop: '#FF7D5F',
        faded: '#FFA894',
        colorMatrix: '0 0 0 0 0.921569 0 0 0 0 0.286275 0 0 0 0 0.145098 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.941176 0 0 0 0 0.486275 0 0 0 0 0.384314 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }

    case TopicId.GEOMETRY:
      return {
        start: '#6966EC',
        stop: '#7F7CFB',
        faded: '#A6A4F0',
        colorMatrix: '0 0 0 0 0.388235 0 0 0 0 0.376471 0 0 0 0 0.898039 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.501961 0 0 0 0 0.490196 0 0 0 0 0.952941 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }

    case TopicId.NUMBERS:
      return {
        start: '#DE74FF',
        stop: '#A840C8',
        faded: '#EDB1FF',
        colorMatrix: '0 0 0 0 0.670588 0 0 0 0 0.262745 0 0 0 0 0.796078 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.862745 0 0 0 0 0.443137 0 0 0 0 0.992157 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }

    case TopicId.PROOFS:
      return {
        start: '#E17A00',
        stop: '#FFA336',
        faded: '#F4BD7B',
        colorMatrix: '0 0 0 0 0.890196 0 0 0 0 0.490196 0 0 0 0 0.0117647 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.913725 0 0 0 0 0.572549 0 0 0 0 0.164706 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }

    case TopicId.STATISTICS:
      return {
        start: '#FA0E9A',
        stop: '#FF71C5',
        faded: '#FF9CD7',
        colorMatrix: '0 0 0 0 0.905882 0 0 0 0 0.0745098 0 0 0 0 0.568627 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.933333 0 0 0 0 0.388235 0 0 0 0 0.709804 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }

    default:
      return {
        start: '#DE74FF',
        stop: '#A840C8',
        faded: '#EDB1FF',
        colorMatrix: '0 0 0 0 0.670588 0 0 0 0 0.262745 0 0 0 0 0.796078 0 0 0 1 0',
        fadedMatrix: '0 0 0 0 0.862745 0 0 0 0 0.443137 0 0 0 0 0.992157 0 0 0 1 0',
        completedMatrix: '0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 0 0.832844 0 0 0 1 0',
        completed: '#FFA825',
        completedInnerIconOpacity: 0.75,
      }
  }
}

export function getTaskBgGradient(category: TopicId): string {
  switch (category) {
    case TopicId.ALGEBRA:
      return 'bg-task-algebra-gradient'

    case TopicId.FUNCTIONS:
      return 'bg-task-functions-gradient'

    case TopicId.GEOMETRY:
      return 'bg-task-geometry-gradient'

    case TopicId.NUMBERS:
      return 'bg-task-numbers-gradient'

    case TopicId.PROOFS:
      return 'bg-task-proofs-gradient'

    case TopicId.STATISTICS:
      return 'bg-task-statistics-gradient'

    default:
      return 'bg-task-numbers-gradient'
  }
}
